var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 0.5H3.5C2.6709 0.5 2 1.1709 2 2V14C2 14.8291 2.6709 15.5 3.5 15.5H12.5C13.3291 15.5 14 14.8291 14 14V4.25L10.25 0.5ZM5.75 6.5C6.16309 6.5 6.5 6.83691 6.5 7.25C6.5 7.66309 6.16309 8 5.75 8C5.33691 8 5 7.66309 5 7.25C5 6.83691 5.33691 6.5 5.75 6.5ZM4.25 11.75L6.5 8.75L8 10.25L9.5 8L11.75 11.75H4.25Z",
    fill: "#FF5F5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFileIcon);
export default __webpack_public_path__ + "static/media/img-file-icon.7bc4367294b4342cb386be843701d2fe.svg";
export { ForwardRef as ReactComponent };